import { render, staticRenderFns } from "./CmsEdit.vue?vue&type=template&id=805c05c4&"
import script from "./CmsEdit.vue?vue&type=script&lang=js&"
export * from "./CmsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports